export function parseNumberFromString(string: string): number {
  return parseInt(string.replace(/[^\d]/g, ''), 10);
}
